/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  OverlayTrigger,
  FormControl,
  ControlLabel,
  FormGroup,
  Pagination,
  Tooltip,
} from "react-bootstrap";
import {
  getMedicationcategory,
  getCity,
  Get_Settings,
} from "../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import { Link, withRouter } from "react-router-dom";
import ReactTable from "react-table";
import LoadingSpinner from "views/Components/loadingSpinner";

import SweetAlert from "react-bootstrap-sweetalert";

import Switch from "react-bootstrap-switch";

import Card from "components/Card/Card.jsx";

import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import { getApiErrorMessage } from "utils/getApiErrorMessage";
class settinglist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setting_details: [],
      page: "",
      _notificationSystem: null,
      alert: null,
      useraccess: "",
      medicationfile: null,
      city: "0",
      showbulkui: 0,
      noRecordFound: false,
      loading: false,
      city_info: [],
    };
    this.fileInput = React.createRef();
    this.selectedmedication = this.selectedmedication.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.searchdata = this.searchdata.bind(this);
    this.searchData = this.searchData.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
  }
  selectedmedication(cus) {
    // console.log(cus);
    localStorage.setItem("medicationID", JSON.stringify(cus));
    this.props.history.push("/admin/edit_medication");
  }
  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    this.searchData();
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;
  }
  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {getApiErrorMessage(error)}
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
    this.searchdata();
  };
  paginationinfo(url) {
    this.setState({ page: url });
    this.searchData();
  }
  searchdata(e) {
    this.setState({ page: "" });
    this.searchData();
  }
  resetSearch(e) {
    this.setState({
      itemcode: "",
      title: "",
      medicationcategory: "",
      price: "",
      commision: "",
      unitprice: "",
      city: "0",
    });
    this.searchData();
  }
  subStrAfterChars(str, char, pos) {
    if (pos == "b") return str.substring(str.indexOf(char) + 1);
    else if (pos == "a") return str.substring(0, str.indexOf(char));
    else return str;
  }
  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;
    this.setState({ noRecordFound: false });

    // console.log(this.state.itemcode,this.state.description,this.state.price,this.state.medicationcategory,this.state.commision,this.state.unitprice,this.state.page)
    this.setState({ loading: true }, () => {
      Get_Settings(obj)
        .then((response1) => {
          var data = response1.data;
          console.log(data);
          if (data.data.length == 0) {
            this.setState({ noRecordFound: true });
          } else {
            this.setState({ setting_details: data.data });
          }

          this.setState({
            loading: false,
          });
        })
        .catch((error) => {
          console.log(error, "== error");
          this.handleNetworkError("bl", error);
        });
    });
  }
  warningWithConfirmAndCancelMessage(id) {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deletemedicaton(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this Medication Detail !
        </SweetAlert>
      ),
    });
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  updatecommision(key) {
    localStorage.setItem("commisionid", JSON.stringify(key));
    this.props.history.push("/admin/edit_commision");
  }
  updatesetting(id) {
    localStorage.setItem("settingid", JSON.stringify(id));
    this.props.history.push("/admin/edit_setting");
  }

  render() {
    const change_status = (
      <Tooltip id="change_status">Change Feature Status</Tooltip>
    );
    const view = <Tooltip id="view">View Profile</Tooltip>;
    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;
    const medication_detail = this.state.medication_detail;
    const setting_details = this.state.setting_details;
    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={12}>
              <Card
                tableFullWidth
                content={
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12}></Col>

                    <br />

                    <Col xs={12} sm={12} md={12} lg={12}>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Setting Lable</th>
                            <th> Setting Key</th>
                            <th>Setting Value</th>
                            <th className="text-right">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading ? (
                            <tr>
                              <td colspan="10">
                                <LoadingSpinner />
                              </td>
                            </tr>
                          ) : this.state.noRecordFound ? (
                            <tr>
                              <td colspan="10">
                                <center>No record found</center>
                              </td>
                            </tr>
                          ) : (
                            <React.Fragment>
                              {setting_details.map((sett) => (
                                <tr>
                                  <td>{sett.setting_label}</td>
                                  <td>{sett.setting_key}</td>
                                  <td>{sett.setting_value}</td>
                                  <td className="td-actions text-right no-padding">
                                    {sett.setting_key ===
                                    "medication_commision" ? (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={edit}
                                      >
                                        <Button
                                          simple
                                          bsStyle="success"
                                          onClick={this.updatecommision.bind(
                                            this,
                                            sett.id
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-edit" />
                                        </Button>
                                      </OverlayTrigger>
                                    ) : (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={edit}
                                      >
                                        <Button
                                          simple
                                          bsStyle="success"
                                          onClick={this.updatesetting.bind(
                                            this,
                                            sett.id
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-edit" />
                                        </Button>
                                      </OverlayTrigger>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </React.Fragment>
                          )}
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default settinglist;
